import React from 'react'
import NavBar from '../components/navBar'
import { ToastContainer } from 'react-toastify'

export default function Layout({ children, back = -1, home = -1 }) {
    
    return (
        <div className='flex flex-col w-full max-w-[500px] min-h-screen min-h-[100dvh] mx-auto'>
            <div className='flex-1 overflow-y-auto pb-24 px-2 scale-100 sm:scale-90 sm:pb-20'>
                {children}
            </div>
            <NavBar back={back} home={home} />
            <ToastContainer position="top-center" theme='colored'/>
        </div>
    )
}
